<template>
    <div class="flex-fill d-flex position-relative">
		<div v-if="groupconvo || prospect" class="grpmsglogdiv bg-white border flex-fill d-flex flex-column overflow-auto">
			<div class="border-bottom justify-content-between position-relative p-2 d-flex">
				<!-- <b-button id="ConvoBackButton" variant="outline" class="position-relative" @click="$emit('groupopen', 'grouplist')">
					<v-icon name="arrow-left" scale="1" class="text-blue" />
				</b-button> -->
				<!-- {{this.groupconvo}} -->
				<div class="w-100">
					<div v-if="groupconvo" class="d-flex before-icon">
						
						<h5 style="display: flex;align-items: end;" v-if="FriendlyNameEditField">
							<b-form-input
								type="text"
								v-model="form.friendlyName"
							/>
						</h5>

						<h5 style="display: flex;align-items: end;"  v-if="FriendlyNameStatic">{{toptitle()}}
							<!--<span 
								v-if="isOverDue.val"
								:class="getClassName"
								:id="this.getId" 
								style="padding:0px;background-color: transparent;border-color: transparent;"
							>!</span>
							
							
								<b-popover 	
								:target="this.getId" 
								triggers="hover" 
								placement="auto" 
								container="my-container" 
								ref="popover"
							>
								
								<b-table-simple v-if="prospect.Tasks" bordered striped responsive hover class="mx-auto text-left middle-grid-sc">
									<b-thead head-variant="light">
										<b-tr class="text-center">
											<b-th>Due Date</b-th>
											<b-th>Task</b-th>
										</b-tr>
									</b-thead>
									<b-tbody>
										<b-tr
											:key="task.CreatedOn"
											class="text-left position-relative"
											v-for="task of TaskList"
											:class="{'table-danger': task.Status == 'draft' && (task.DueOn <= Date.now())}"
										>
											<b-td>{{$parseDate(task.DueOn)}}</b-td>
											<b-td class="pr-5 position-relative">{{task.Description}}
												<b-button v-if="task.Status != 'compeleted'"
													style="right: 25px"
													variant="outline"
													class="center-vert"
													@click="compeleteTask(task)"
												>
													<v-icon class="text-blue" name="check" />
												</b-button>
												<b-button
													style="right: 0"
													variant="outline"
													class="center-vert"
													@click="removeTask(task)"
												>
													<v-icon class="text-blue" name="times" />
												</b-button>
											</b-td>
										</b-tr>
									</b-tbody>
								</b-table-simple>


							</b-popover>-->
							<!-- <div v-if="!prospect.Starred" @click.stop.prevent="startMessage()">
								<v-icon :class="{ 'show_star': !prospect.Starred }" class="text-white start-default" scale="1" name="star" ></v-icon>
							</div>
							<span @click.stop.prevent="unStartMessage()" style="margin-left: 0px;margin-top: -6px;">
								<v-icon v-if="prospect.Starred" class="text-blue start-default" scale="1" name="star" ></v-icon>
							</span> -->
						</h5>	

						<span class="nameeidtspan" @click="FriendlyNameEdit()" v-if="FriendlyNameEditIF" title="Edit">
							<v-icon class="text-blue" name="edit" />
						</span>
						
						<span class="nameeidtspan" @click="FriendlyNameSave" v-if="FriendlyNameSaveIF" title="Save" style="padding-top: 7px;">
							<v-icon class="text-blue" name="check" />
						</span>
						
						<!-- <span class="ml-auto my-auto"> -->
						<!-- <span v-if="prospect && prospect.hasOwnProperty('CciMap') && Object.keys(prospect.CciMap).length && prospect.CciMap.Priority" class="ml-auto my-auto w-100 d-inline-block text-right"> <a style="color:#007bff" class="cursor-pointer" @click="openPriorityModal({},'openedFromAssessment')">Priority: {{prospect.CciMap.Priority}}</a></span> -->
						<!-- <span v-if="prospect && prospect.hasOwnProperty('CciMap') && Object.keys(prospect.CciMap).length" class="ml-auto my-auto w-100 d-inline-block text-right"> <a style="color:#007bff" class="cursor-pointer" @click="openPriorityModal({},'openedFromAssessment')">Priority: {{prospect.CciMap.Priority}}</a></span> -->
						<!-- </span> -->
					</div>
					<!-- <v-icon class="text-blue" name="edit" @onClick="FriendlyNameClick" /> -->

						<!-- <div class="d-flex">
						<h5 v-if="prospect">{{$parseNumber(prospect.Number)}}</h5>
				
					<h3 v-else >{{$parseNumber(convo.ClientNumber)}}</h3>
					<div v-if="hasCarrierType">
						<strong v-if="prospect.CarrierType == 'mobile' || prospect.CarrierType == 'voip'" v-b-tooltip.hover title="Validated mobile phone number" class="text-danger" style="margin-left:12px">
							<v-icon name="check" class="text-blue" />
						</strong>
						<strong v-else v-b-tooltip.hover title="Not a valid mobile number. Prospect can’t be messaged." class="text-danger" style="margin-left:12px">
							<svg style="width:24px;height:24px" viewBox="0 0 24 24">
								<path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
							</svg>
						</strong>
					</div>
					</div> -->
					
				</div>
				<!-- <b-button  variant="outline" class="position-relative" @click="openEmailModal()"  style="margin-right: -20px;">
					<v-icon name="envelope-o" scale="3" class="text-blue" />
				</b-button> -->
				<!-- <b-button variant="outline" class="position-relative" @click="openEmailModal({},'withoutDetails')">
					<v-icon name="envelope" scale="3" class="text-blue" />
				</b-button>
				<b-button v-if="prospect" variant="outline" class="position-relative" @click="makeCallClick()">
					<v-icon name="phone-square-alt" scale="3" class="text-blue" />
				</b-button>
				<b-button variant="outline" class="position-relative" @click="$emit('open', 'prosp')">
					<v-icon name="info-circle" scale="3" class="text-blue" />
				</b-button> -->
				
				<!-- <b-button variant="outline" class="position-relative" @click="$emit('groupopen', 'prosp')">
					<v-icon name="info-circle" scale="3" class="text-blue" />
				</b-button> -->
				<b-button variant="outline" class="emailndcallbtn deviceProsInfoTab position-relative" @click="openGrpProspectDetails()" style="padding:0px;">
					<v-icon name="info-circle" scale="2" class="text-blue" />
				</b-button>			
			</div>
			<div ref="grpmessageLog" v-if="grpmessages.length || Object.keys(sending).length || Object.keys(failed).length" v-on:scroll="OnScroll" class="p-3 flex-fill d-flex flex-column overflow-auto">
				<div class="flex-fill" />
				<groupMessage
					:key="message.id"
					:message="message"
					@resend="resendError(message)"
					@delete="deleteError(message)"
					@cancelClick="cancelClick()"
					@openEmailM="openEmailModal"
					v-for="message in collatedMessages"
					
				/>
			</div>
			<div v-else class="flex-fill position-relative">
				<h6 class="text-black-50 center">This Group conversation is empty</h6>
			</div>
			<div v-if="hideDiv && messageType == 'message'" class="border bg-light d-flex align-items-end p-3">
				<div style="position:relative;    display: flex;justify-content: space-between;width: 100%;">
					<!-- <v-icon name="spinner"  scale="1.5" class=" m-2 text-blue" /> -->
					<span v-if="!uplodedFilePath">Loading...</span>
					<a v-if="uplodedFilePath && isImage" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
						<img width="60" :src="uplodedFilePath"/>
					</a>
					<a v-if="uplodedFilePath && isAudio" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
						<v-icon scale="2.5" name="music" />
					</a>
					<a v-if="uplodedFilePath && isVideo" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
						<v-icon scale="2.5" name="video" />
					</a>
					<a v-if="uplodedFilePath && isDocument" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
						<v-icon scale="2.5" name="file" />
					</a>
					<b-button variant="outline" class="p-0 mx-1 my-2 primary" @click="removeFile">
						<v-icon name="times"  scale="1.5" class=" m-2 text-blue" />
					</b-button>
				</div>
				
			</div>
			<div class="border bg-light d-flex align-items-center">
				<div class="d-flex align-items-center">
					<b-button variant="outline" class="p-0 mx-1 my-2 bg-white border primary" @click="openTemplateNormal" title="Templates">
						<v-icon name="file-alt" scale="1.5" class="m-2 text-blue" />
					</b-button>
					<!-- <input id="fileUpload" type="file" @change="changeFile($event,'message')" hidden :disabled="hasCarrierType && this.prospect.CarrierType == 'landline'">
					<b-button v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))" variant="outline" class="border" @click="chooseFiles" title="Upload Media" >
						<v-icon name="upload" scale="1.5" class="text-blue"  />
					</b-button> -->
					<div v-if="user.Variables">
						<b-dropdown  right variant="outline" title="Message Variables" split-variant="outline" text="(X)" class="m-2 btn-outline custom-dropdown" toggle-class="text-blue" style="z-index: 1005">
							<b-dropdown-item :key="v.field" v-for="v in user.Variables" @click="insertVariables(v)">{{v.field}}</b-dropdown-item>
						</b-dropdown>
					</div>
				</div>
				<twemoji-textarea 
					:emojiData="emojiDataAll" 
					:emojiGroups="emojiGroups" 
					:skinsSelection="false"
					:searchEmojisFeat="true"
					searchEmojiPlaceholder="Search here."
					searchEmojiNotFound="Emojis not found."
					ref="twemojiTextarea"
					placeholder="Type a message"
					v-model="message"
					class="twemojiTextarea flex-fill"
					@contentChanged="onContentChanged"			
					@keydown.enter.prevent
					@enterKey="send"
					:textareaDisabled="hasCarrierType && this.prospect.CarrierType == 'landline'"
					spellcheck="true"
					v-focus
					title="Emojis">
				</twemoji-textarea>
				<!-- <textarea
					ref="input"
					rows="1"
					class="flex-fill input form-control border mx-1 my-2 p-2"
					placeholder="Type a message"
					v-model="message"
					@keydown.enter.prevent
					@keyup.enter="send"
					spellcheck="true"
					
					v-focus/> -->
				
				<div>
					<b-button v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))" variant="outline" @click="send" class="p-0 mx-1 my-2 bg-white border primary" title="Send Message">
						<v-icon name="arrow-circle-up" scale="1.5" class="m-2 text-blue" />
					</b-button>
				</div>
				<!-- <div v-if="prospect">
					<b-button variant="outline" class="p-0 mx-1 my-2 bg-white border primary" :disabled="hasCarrierType && this.prospect.CarrierType == 'landline'" @click="$bvModal.show('SchedulerModal')" title="Schedule Message">
						<v-icon name="calendar-alt" scale="1.5" class="m-2 text-blue" />
					</b-button>
				</div> -->
			</div>
		</div>
		<h4 v-else class="centerTextAlign center">Please select a conversation</h4>
		<b-modal id="TemplateModal" size="lg" hide-footer>
			<template v-slot:modal-title class="custom-header">
				Saved Templates
				<b-button  variant="outline" @click="addNewTemplate" class="custom-btn p-0 bg-white border primary" title="Send Message">
					Add New
				</b-button>
			</template>
			
			<div v-if="!isShowTemplateList">
				<b-form-group label="Template Name: " class="text-left">
					<b-form-input v-model="templateForm.Name" required />
				</b-form-group>
				<div class="custom-border">
					<b-form-group label="Message: " class="text-left schedule-textbox" style="position:relative;">
					
					<b-button-group class="w-100">
						<b-button type="button" class="border rounded-top-left flex-fill" variant="outline" @click="addTemplateText('{{firstName}}')">
								First
						</b-button>
						<b-button type="button" class="border rounded-0 flex-fill" variant="outline" @click="addTemplateText('{{lastName}}')">
								Last
						</b-button>
						<b-button type="button" class="border rounded-0 flex-fill" variant="outline" @click="addTemplateText('{{email}}')">
								Email
						</b-button>
						<b-button type="button" class="border rounded-top-right flex-fill" variant="outline" @click="addTemplateText('{{number}}')">
								Number
						</b-button>
					</b-button-group>
					<input id="fileUploadSch" type="file" @change="changeFile($event,'templateMessage')" hidden>
					<b-button  variant="outline" style="top:93px;" class="border schedule-upload" @click="chooseFilesSch"  >
						<v-icon name="upload" scale="1.3" class="text-blue" />
					</b-button>
					<twemoji-textarea 
						:emojiData="emojiDataAll" 
						:emojiGroups="emojiGroups" 
						:skinsSelection="false"
						:searchEmojisFeat="true"
						searchEmojiPlaceholder="Search here."
						searchEmojiNotFound="Emojis not found."
						ref="templatetwemojiTextarea"
						placeholder="Type a message"
						v-model="templateForm.Body"
						class="twemojiTextarea flex-fill scedule-emoji"
						@contentChanged="onTemplateContentChanged"			
						@keydown.enter.prevent
						spellcheck="true"
						v-focus
						title="Emojis">
					</twemoji-textarea>
					
				</b-form-group>
				<div v-if="hideDiv && messageType == 'templateMessage'" class="border bg-light d-flex align-items-end p-3">
					<div style="position:relative;    display: flex;justify-content: space-between;width: 100%;">
						
						<span v-if="!uplodedFilePath">Loading...</span>
						<a v-if="uplodedFilePath && isImage" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<img width="60" :src="uplodedFilePath"/>
						</a>
						<a v-if="uplodedFilePath && isAudio" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<v-icon scale="2.5" name="music" />
						</a>
						<a v-if="uplodedFilePath && isVideo" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<v-icon scale="2.5" name="video" />
						</a>
						<a v-if="uplodedFilePath && isDocument" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<v-icon scale="2.5" name="file" />
						</a>
						<b-button variant="outline" class="p-0 mx-1 my-2 primary" @click="removeFile">
							<v-icon name="times"  scale="1.5" class=" m-2 text-blue" />
						</b-button>
					</div>
					
				</div>
				</div>
				

				<b-button  variant="outline" @click="saveNewTemplate" class="custom-btn custom-save-btn p-0 mx-1 my-2 bg-white border primary" title="Send Message">
					Save Template
				</b-button>
			</div>

			<div v-if="isShowTemplateList" class="w-90 mx-auto">
				<div class="templatesearchbar">
					<b-input type="search" placeholder="Search Templates..." v-model="searchQuery" />
				</div>
			</div>
			
			<b-table-simple v-if="isShowTemplateList" bordered responsive striped hover sticky-header="28em" class="w-90 mx-auto text-left" >
				<b-thead head-variant="light">
					<b-tr class="text-center">
						<b-th>Template Name</b-th>
						<b-th>Message</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<b-tr
						class="text-left pointer"
						:key="i"
						v-for="(item,i) in filteredTasks"
						@click="fill(item)">
							<b-td>{{item.Name}}</b-td>
							<b-td>{{item.Message}}
								<a v-if="item.mediaUrl"  variant="outline" class="p-0 mx-1 my-2 primary">
									<v-icon scale="2.5" name="file" />
								</a>
							</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-modal>
		
		
	
		<!-- <b-modal id="DailerModal" size="sm" hide-footer hide-header centered   no-close-on-esc hide-backdrop no-close-on-backdrop>
			
			<div class="calling_wrapper" >
				<div class="calling-container">
					<div class="calling_rightside">
						<div class="d-flex align-center"  style="align-items:center;width: 100%; justify-content: flex-end;" >
							<span>{{callProspFullName}}</span>
							<div class="calling_icons">
								<div><button v-if="!muted" class="mic_btn" type="button"  @click="toggleMute" >
									<v-icon name="microphone" scale="2" class="text-blue" />
								</button>
								<button v-if="muted" class="mic_btn_mute" type="button"    @click="toggleMute">
									<v-icon name="microphone-slash" scale="2" class="text-blue" />
								</button>
								</div>
								
						
								
								<button class="reject_btn" type="button" @click="toggleCall">
									<v-icon name="phone" scale="2" class="text-blue" />
								</button>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</b-modal> -->

		<!-- <modal name="my-first-modal" :draggable="true" :clickToClose="false">
			<div class="calling_wrapper" >
				<div class="calling-container">
					<div class="calling_rightside">
						<div class="d-flex align-center"  style="align-items:center;width: 100%; justify-content: flex-end;" >
							<span>{{callProspFullName}}</span>
							<div class="calling_icons">
								<div><button v-if="!muted" class="mic_btn" type="button"  @click="toggleMute" >
									<v-icon name="microphone" scale="2" class="text-blue" />
								</button>
								<button v-if="muted" class="mic_btn_mute" type="button"    @click="toggleMute">
									<v-icon name="microphone-slash" scale="2" class="text-blue" />
								</button>
								</div>
								
						
								
								<button class="reject_btn" type="button" @click="toggleCall">
									<v-icon name="phone" scale="2" class="text-blue" />
								</button>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</modal> -->
	

		<!-- <div v-if="onPhone" class="testmove" ref="someTarget">
			<movable  class="modaltitle " target="someTarget"  >{{callProspFullName}}</movable>
			<div class="calling_wrapper" >
				<div class="calling-container">
					<div class="calling_rightside">
						<div class="d-flex align-center" style="align-items:center;width: 100%; justify-content: flex-end;">
							
							<div class="calling_icons">
								<div><button v-if="!muted" class="mic_btn" type="button"  @click="toggleMute" >
									<v-icon name="microphone" scale="2" class="text-blue" />
								</button>
								<button v-if="muted" class="mic_btn_mute" type="button"    @click="toggleMute">
									<v-icon name="microphone-slash" scale="2" class="text-blue" />
								</button>
								</div>
								
						
								
								<button class="reject_btn" type="button" @click="toggleCall">
									<v-icon name="phone" scale="2" class="text-blue" />
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div> -->

		<!-- <b-modal id="EmailModal" centered  size="lg" hide-footer>
			<template v-slot:modal-title class="custom-header">
				Send Email
			</template>
			<EmailModal :emailData="emailData" />
		</b-modal> -->

		<!-- <b-modal id="priorityModal" centered  size="lg" hide-footer>
			<template v-slot:modal-title class="custom-header">
				{{priorityModalData.First}} {{priorityModalData.Last}} Assessment Results
			</template>
			<PriorityDetailModal :emailData="emailData" :priorityData="priorityModalData" :defaultProfile="defaultProfileData" />
		</b-modal> -->
		
		
		<!-- <movable class="t	estmove" posTop="444" :grid="20"><span>grid:20</span></movable> -->
	</div>
</template>
<!--<script src="//media.twiliocdn.com/sdk/js/client/v1.4/twilio.min.js"></script>-->
<script>
	import { db,fbstore } from 'src/db'
	import { mapState } from 'vuex';
	import groupMessage from './groupMessage';
	import { TwemojiTextarea } from '@kevinfaguiar/vue-twemoji-picker';
	import  EmojiAllData  from '@kevinfaguiar/vue-twemoji-picker/emoji-data/en/emoji-all-groups.json';
	import EmojiGroups from '@kevinfaguiar/vue-twemoji-picker/emoji-data/emoji-groups.json';
	import axios from "axios";
	// import { Twilio }	 from 'twilio'
	// const { Twilio } = require('twilio-client');
	import { Device } from 'twilio-client';
	// import EmailModal from "./EmailModal.vue";
	// import PriorityDetailModal from "./PriorityDetailModal.vue";

	export default {
        name: "groupMessageLog",
        props: {
            prospect: Object,
            groupconvo: {
				UserNumber: String,
				Unread: Number,
			}
        },
        components: {
			groupMessage,
			// EmailModal,
			// PriorityDetailModal,
			'twemoji-textarea': TwemojiTextarea
        },
		computed: {
			filteredTasks () {
				if(this.searchQuery){
					return this.user.Template.filter((item)=>{
						// return item.Message.startsWith(this.searchQuery);
						// return item.Message.toLowerCase().includes(this.searchQuery);
						return item.Message.indexOf(this.searchQuery) > -1 || item.Name.indexOf(this.searchQuery) > -1;
					})
				}else{
					return this.user.Template;
				}
			},

			hasCarrierType() {
				if(this.prospect) {
					return Object.keys(this.prospect).includes('CarrierType');
				}
				return false
			},
			emojiDataAll() {
				return EmojiAllData;
			},
			emojiGroups() {
				return EmojiGroups;
			},
			isDisable() {
				if (this.hasCarrierType) {
					if (this.hasCarrierType && this.prospect.CarrierType == 'mobile') {
						return true;
					}else {
						return false;
					}
				}
				return false;
			},
			minDate() {
				return new Date();
			},
			maxDate() {
				let maxDate = new Date();
				maxDate.setDate(maxDate.getDate() + 30);
				return maxDate;
			},
			collatedMessages() {
				//eslint-disable-next-line
				console.log('645',this.grpmessages)
				let all = [...this.grpmessages, ...Object.values(this.sending), ...Object.values(this.failed)];
				
				const AllLength = all.length;
				if(AllLength - (this.OnLoadMsgLimit * this.ScrollCount) > 0) { // 22 - 10*3(30)
					return all.sort((m2, m1) => m2.Date - m1.Date).slice(AllLength - (this.OnLoadMsgLimit * this.ScrollCount), AllLength);
				} else {
					return all.sort((m2, m1) => m2.Date - m1.Date);
				}
			},
			isImage() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.imageFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isAudio() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.audioFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isVideo() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.videoFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isDocument() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.documentFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			// isOverDue() {
			// 	let val = false;
			// 	let taskType = '';
			// 	if(this.prospect && this.prospect.Tasks) {
			// 		for (let task of this.prospect.Tasks) {
			// 			var date_3_day = new Date();
			// 			date_3_day.setDate(date_3_day.getDate() + 3);
			// 			// var date_1_day = new Date();
			// 			// date_1_day.setDate(date_1_day.getDate() + 1);
			// 			var end = new Date();
			// 			end.setHours(23,59,59,999);
			// 			if (task.DueOn && task.Status == 'draft' && (this.isToday(new Date(task.DueOn)))) {
			// 				taskType = 'red'
			// 				val = true;
			// 				break;
			// 			}else if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now())) {
			// 				taskType = 'red'
			// 				val = true;
			// 			}else if (task.DueOn && task.Status == 'draft' && (task.DueOn < (date_3_day.getTime()) && task.DueOn > (end.getTime()))) {
			// 				val = true;
			// 				taskType = 'yellow';
			// 			}
			// 			else if(task.DueOn && task.Status == 'draft') {
			// 				val = true;
			// 				taskType = 'gray';
			// 			}
			// 		}
			// 	}
			// 	return {val,taskType}
			// },
			// TaskList() {
			// 	let unCompeletedTaskList = [];
			// 	for (let task of this.prospect.Tasks) {
			// 		var someDate = new Date();
			// 		someDate.setDate(someDate.getDate() + 3);
			// 		// if (task.DueOn && task.Status == 'draft' && ((task.DueOn <= (someDate.getTime()) && task.DueOn >=  Date.now() || task.DueOn <= Date.now()))) {
			// 		// 	unCompeletedTaskList.push(task)
			// 		// }
			// 		// unCompeletedTaskList.push(task)
			// 		if (task.DueOn && task.Status == 'draft') {
			// 			unCompeletedTaskList.push(task)
			// 		}
			// 	}
			// 	return unCompeletedTaskList;
			// },
			getId() {
				return  "test_"+this.prospect.id;
			},
			// getClassName() {
			// 	let cname = '';
			// 	if (this.isOverDue.taskType == 'yellow') {
			// 		cname = 'yellow'
			// 	}else if(this.isOverDue.taskType == 'gray') {
			// 		cname = 'gray'
			// 	}else if (this.isOverDue.taskType == 'red') {
			// 		cname = 'red'
			// 	}
			// 	return cname;
			// },
			...mapState('globals', ['activegroupConvo', 'activegroupProsp','unreadCountTotal']),
			...mapState('firebase', ['user', 'grpmessages', 'groupconvos', 'prospects'])
		},
        methods: {
			openGrpProspectDetails() {
				var ml = document.getElementById("grpMessageLog");
				if(ml) { ml.style.zIndex ="0"; }
				var ml2 = document.getElementById("Prospect");
				if(ml2) { ml2.style.zIndex ="1001"; }
			},
			toptitle() {
				var gp = this.groupconvos.find(g => g.id == this.activegroupConvo);
				this.currentCovno = gp;
				let namee;
				if(gp.hasOwnProperty('FriendlyName') && gp.FriendlyName != '') {
					namee = gp.FriendlyName;
				} else {
					let nameeArray = [];
					gp.ProspectNumbers.forEach(gp => {
                        var getData = this.prospects.find(uo => uo.Number == gp);
						if(getData) {
							nameeArray.push(getData.First+' '+getData.Last);
						}
					});
					namee = nameeArray.join(", ");
				}
				return namee;
			},
			FriendlyNameEdit() {
				this.FriendlyNameEditIF=false;
				this.FriendlyNameEditField=true;
				this.FriendlyNameSaveIF=true;
				this.FriendlyNameStatic=false;
				this.form.friendlyName = this.currentCovno.FriendlyName;
			},
			// UPDATE FRIENDLY NAME
			FriendlyNameSave() {
				this.FriendlyNameEditIF=true;
				this.FriendlyNameEditField=false;
				this.FriendlyNameSaveIF=false;
				this.FriendlyNameStatic=true;
				// let a=db.collection(`Conversations_v2/${this.currentCovno.id}`).get();
				//eslint-disable-next-line
				// console.log('a', this.currentCovno);

				// if(this.currentCovno.hasOwnProperty('FriendlyName')) {
				// 	// db.doc(`Conversations_v2/${this.currentCovno.id}`).update({FriendlyName:this.form.friendlyName});
				// } else {

				// }

				const mydata = {
					ConversationSid:this.currentCovno.id,
					friendlyName:this.form.friendlyName
				};
				// eslint-disable-next-line
				console.log('Update conversation Name',mydata);
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/updateConversations", mydata)
				.then(response => {
					// eslint-disable-next-line
					console.log('Update conversation Name',response);
				})
				.catch(err => alert(`Failure Update conversation: ${err}`));
				
				
				
			},
			// load more Message in chat while scrolling
			OnScroll() {
				let component = this.$refs.grpmessageLog;
				if(component.scrollTop == 0) {
					this.ScrollCount++;
					this.collatedMessages;
					this.$refs.grpmessageLog.scrollTop = 1;
				}
			},
			// createCampaign() {
			// 	if (!this.form.body && !this.uplodedFilePath) {
			// 		alert('Please enter message content');
			// 		return
			// 	}
			// 	if (!this.form.date || !this.form.time) {
			// 		alert('Please select date and time');
			// 		return
			// 	}
			// 	let ms = new Date(`${this.form.date} ${this.form.time}`).valueOf();
			// 	if (ms < this.minDate || ms > this.maxDate) {
			// 		alert("Sheduled Date/Time is either in the past or further than 30 days in the future");
			// 		return;
			// 	}
			// 	this.isSending = true;
			// 	const smsData = {
			// 		pid:this.user.id,
			// 		// cid:this.activeProsp,
			// 		body:this.form.body,
			// 		SendOn:ms,
			// 		mediaUrl:this.uplodedFilePath,
			// 	};
			// 	axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/automatedSms", smsData)
			// 	.then(response => {
			// 		// eslint-disable-next-line
			// 		console.log(response);
			// 		this.isSending = false;
			// 		this.form = {};
			// 		this.$bvModal.hide('SchedulerModal');
			// 	}).catch(err => alert(`Failure scheduling message: ${err}`));
			// 	// scheduleCampaign({
			// 	// 	Name: this.form.name,
			// 	// 	Recipients: [this.prospect.id],
			// 	// 	Body: this.form.body,
			// 	// 	DateTime: ms
			// 	// })
			// 	// .then(() => alert(`Message has been scheduled for ${this.$parseDate(ms)}`))
			// 	// .catch(err => alert(`Failure scheduling message: ${err.response.data.message}`));
			// 	// this.form = {};
				
			// },
			// isToday(date) {
			// 	const today = new Date()
			// 	return date.getDate() === today.getDate() &&
			// 		date.getMonth() === today.getMonth() &&
			// 		date.getFullYear() === today.getFullYear();
			// },
			onContentChanged(c) {
				this.message = c;
			},
			cleanText() {
				this.$refs.twemojiTextarea.cleanText();
			},
			addText(text) {
				this.$refs.twemojiTextarea.addText(text);
			},
			addScheduleText(text) {
				this.$refs.scheduletwemojiTextarea.addText(text);
			},
			async send(event) {
				
				//eslint-disable-next-line
				console.log('send msg event', event);
				//eslint-disable-next-line
				console.log('send msg this.groupconvo>', this.groupconvo);
				//eslint-disable-next-line
				console.log('send msg this.prospect', this.prospect);
				
				// if (this.prospect.hasOwnProperty('Status') && this.prospect.Status == "Archived") {
				// 	alert('Archived prospects can not be messaged.');
				// 	return;
				// }
				if (event.shiftKey) {
					this.message += '\n';
					return;
				}
				if (this.message == "" && this.uplodedFilePath == '') {
					return;
				}
				let body = this.message, id = Object.keys(this.sending).length, date = new Date();
				this.message = "";
				this.cleanText();
				this.$set(this.sending, id, {Body: body, Date: date, Incoming: false, Status: 'Sending'});

				const searchUser = {
					ConversationSid: this.groupconvo.id,
					Author: this.groupconvo.UserNumber,
					Body: body,
					mediaUrl:this.uplodedFilePath,
					Uid:this.groupconvo.Uid
				};
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/sendGroup", searchUser)
				.then(response => {
					//eslint-disable-next-line
					console.log('response', response)
				})
				.catch(() => {
					this.uplodedFilePath = '';
					this.hideDiv = false;
					this.$set(this.failed, id, {Body: body, Date: date, Incoming: false, Status: 'Failed'});
				})
				.finally(() => {
					this.uplodedFilePath = '';
					this.hideDiv = false;
					this.$delete(this.sending, id);
				})
			},
			async resendError(message) {
				let current, id;
				for (id in this.failed) {
					current = this.failed[id];
					if (current.Date == message.Date && current.Body == message.Body) {
						this.$delete(this.failed, id);
						break;
					}
				}
				id = Object.keys(this.sending).length;
				this.$set(this.sending, id, {Body: current.Body, Date: current.Date, Incoming: false, Status: 'Sending'});

				const searchUser = {
					ConversationSid: this.groupconvo.id,
					Author: this.groupconvo.UserNumber,
					Body: current.body,
					mediaUrl:this.uplodedFilePath,
					Uid:this.groupconvo.Uid
				};
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/sendGroup", searchUser)
				.then(response => {
					//eslint-disable-next-line
					console.log('response', response)
				})
				// sendGroupMessage({
				// 	To: this.groupconvo.ClientNumber,
				// 	Body: current.Body,
				// 	mediaUrl:this.uplodedFilePath,
				// 	Uid:this.groupconvo.Uid
				// })
				.catch(() => {
					this.$set(this.failed, id, {Body: current.Body, Date: current.Date, Incoming: false, Status: 'Failed'});
				})
				.finally(() => {
					this.$delete(this.sending, id);
				})
			},
			deleteError(message) {
				let current;
				for (let id in this.failed) {
					current = this.failed[id];
					if (current.Date == message.Date && current.Body == message.Body) {
						this.$delete(this.failed, id);
						break;
					}
				}
			},
			fill(item) {
				let message = item.Message
				if (item && item.hasOwnProperty('mediaUrl') && item.mediaUrl) {
					this.uplodedFilePath = item.mediaUrl;
					this.hideDiv = true;
				}
				if (this.prospect) {
					let edited = message.replace(/{{firstName}}/g, this.prospect.First ? this.prospect.First : '');
					edited = edited.replace(/{{lastName}}/g, this.prospect.Last ? this.prospect.Last : '');
					edited = edited.replace(/{{email}}/g, this.prospect.Email ? this.prospect.Email : '');
					edited = edited.replace(/{{number}}/g, this.$parseNumber(this.prospect.Number));
					if (this.isScheduleTemplate) {
						this.form.body = edited;
					}else {
						this.message = edited;
					}
					this.$bvModal.hide('TemplateModal');
				}
				else {
					this.message = message;
					this.form.body = message;
					this.$bvModal.hide('TemplateModal');
				}
				if (this.isScheduleTemplate) {
					this.messageType = 'scheduleMessage';
					this.addScheduleText(this.form.body);
				}else {
					this.addText(this.message);
				}
				this.isScheduleTemplate = false;
			},
			showTemps() { this.temps = true },
			hideTemps() { this.temps = false },
			showSched() { this.sched = true },
			hideSched() { this.sched = false },
			changeFile(event,type) {
				this.messageType = type;
				this.uploadValue = 0;
				this.uplodedFilePath = '';
				this.fileData = event.target.files[0];
				if (this.supportedType.includes(this.fileData.type)) {
					if (this.fileData.size < 5242880) {
						this.hideDiv = true;
						this.onUpload();
					}else {
						alert('File size must be less than 5MB');
					}
				}else {
					alert('This format is not allow to send message');
				}
				
			},
			
			onUpload(){
				this.uplodedFilePath = '';
				const storageRef = fbstore.ref(`${this.fileData.name}`).put(this.fileData);
				storageRef.on(`state_changed`,snapshot=>{
					this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
				}, error=>{
					//eslint-disable-next-line
					console.log(error.message)
				},
				()=>{this.uploadValue=100;
					storageRef.snapshot.ref.getDownloadURL().then((url)=>{
						this.uplodedFilePath = url;
						this.message = "";
						// this.send({});
					});
				});
			},
			chooseFiles() {
				document.getElementById("fileUpload").click()
			},
			chooseFilesSch() {
				document.getElementById("fileUploadSch").click()
			},
			removeFile() {
				this.uplodedFilePath = '';
				this.hideDiv = false;
			},
			insertVariables(v) {
				this.addText(v.value)
			},
			// startMessage() {
			// 	db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Starred:true});
			// },
			// unStartMessage() {
			// 	db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Starred:false});
			// },
			cancelClick() {
				this.$emit('showLoader');
			},
			onScheduleContentChanged(c) {
				this.form.body = c;
			},
			openTemplate() {
				this.isScheduleTemplate = true;
				this.isShowTemplateList = true;
				this.$bvModal.show('TemplateModal')
			},
			openTemplateNormal() {
				this.isScheduleTemplate = false;
				this.isShowTemplateList = true;
				this.$bvModal.show('TemplateModal')
			},
			// Handle muting
			toggleMute() {
				this.muted = !this.muted;
				Device.activeConnection().mute(this.muted);
			},
			toggleCall: function() {
				if (!this.onPhone) {
					this.muted = false;
					this.onPhone = true;
					// make outbound call with current number
					// var n = '+' + this.countryCode + this.currentNumber.replace(/\D/g, '');
					this.connection = Device.connect({ number: this.callProspNumber,callerID:this.user.Twilio });
					let newCallList = [];
					if (this.prospect.Calls) {
						newCallList = this.prospect.Calls;
					}
					newCallList.push({
							DateTime:Date.now(),
							Direction:'Outgoing',
							Duration:'',
							Status:'Completed',
					});
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Calls:newCallList});
					// setInterval(function(){
					// 	//eslint-disable-next-line
					// 	console.log('hehehehehhe');
					// }, 3000);
					setTimeout(() => {
						this.toggleCall()
					}, 3600000);
				} else {
					// hang up call in progress
					Device.disconnectAll();
					// this.$bvModal.hide('DailerModal');
					// this.$modal.hide('my-first-modal');
				}
			},
			// makeCallClick() {
			// 	if (confirm("Are you sure you want to call this prospect?")) {
			// 		this.callProspFullName = this.$parseAlias(this.prospect);
			// 		this.callProspNumber = this.prospect.Number;
			// 		// this.$bvModal.show('DailerModal');
			// 		// this.$modal.show('my-first-modal');
			// 		// this.toggleCall();
			// 		// this.onPhone = true;
			// 		let callDetailsObject = {
			// 			showCallBox:true,
			// 			ProspName:this.callProspFullName,
			// 			ProspNumber:this.callProspNumber
			// 		}
			// 		this.$emit('getCallDetails',callDetailsObject);
			// 		// this.$emit('changeUser',this.callProspFullName);
					
			// 	}
			// 	// makeCall()
			// 	// .then((res) => {
			// 	// 	//eslint-disable-next-line
			// 	// 	console.log(res);
			// 	// })
			// 	// .catch(err => {
			// 	// 	//eslint-disable-next-line
			// 	// 	console.log(err);
			// 	// });
			// },
			addNewTemplate() {
				this.isShowTemplateList = false;
			},
			addTemplateText(text) {
				this.$refs.templatetwemojiTextarea.addText(text);
			},
			onTemplateContentChanged(c) {
				this.templateForm.Body = c;
			},
			saveNewTemplate() {
				if (this.templateForm.Name || this.templateForm.Body) {
					let isTemplateExist = false;
					for (let temp of this.user.Template) {
						if (this.templateForm.Name == temp.Name) {
							temp.Message = this.templateForm.Body
							isTemplateExist = true;
						}
					}
					if (!isTemplateExist) {
						let newAddedTemplate = [];
						newAddedTemplate = this.user.Template;
						newAddedTemplate.push({
							Name:this.templateForm.Name,
							Message:this.templateForm.Body,
							mediaUrl:this.uplodedFilePath
						});
					}
					//eslint-disable-next-line
					// console.log(this.user.Template);
					this.cleanTemplateText();
					this.templateForm.Name = '';
					this.templateForm.Body = '';
					this.uplodedFilePath = '';
					this.hideDiv=false,
					db.doc(`Users/${this.user.id}`).update({ Template: this.user.Template });
					this.isShowTemplateList = true;
				}else {
					alert('Please add name or body');
				}
			},
			cleanTemplateText() {
				this.$refs.templatetwemojiTextarea.cleanText();
			},
			openEmailModal(message,type) {
				let emailDetailsObject = {
						user:this.user,
						prospect:this.prospect,
						message:message,
						type:type
					}
				this.emailData = emailDetailsObject;
				this.$bvModal.show('EmailModal');

			},
			// calculatePriority(data) {
			// 	let val = 0;
			// 	let pf,pfid;
			// 	if (this.user.hasOwnProperty('CciProfiles') && this.user.CciProfiles) {
			// 		let defaultProfile =  this.user.CciProfiles.find(cp => cp.Default == true);
			// 		//eslint-disable-next-line
			// 		// console.log('defaultProfile', defaultProfile);
			// 		if (defaultProfile) {
			// 			if (
			// 				(data.Builder >= defaultProfile.BuilderLower && data.Builder <= defaultProfile.BuilderUpper) &&
			// 				(data.Merchant >= defaultProfile.MerchantLower && data.Merchant <= defaultProfile.MerchantUpper) && 
			// 				(data.Innovator >= defaultProfile.InnovatorLower && data.Innovator <= defaultProfile.InnovatorUpper) && 
			// 				(data.Banker >= defaultProfile.BankerLower && data.Banker <= defaultProfile.BankerUpper) &&
			// 				(data.Intuitive >= defaultProfile.IntuitiveLower && data.Intuitive <= defaultProfile.IntuitiveUpper) &&
			// 				(data.Cognitive >= defaultProfile.CognitiveLower && data.Cognitive <= defaultProfile.CognitiveUpper) && 
			// 				(data.Practical >= defaultProfile.PracticalLower && data.Practical <= defaultProfile.PracticalUpper) &&
			// 				(data.Creative >= defaultProfile.CreativeLower && data.Creative <= defaultProfile.CreativeUpper) &&
			// 				(data.Independent >= defaultProfile.IndependentLower && data.Independent <= defaultProfile.IndependentUpper) && 
			// 				(data.Community >= defaultProfile.CommunityLower && data.Community <= defaultProfile.CommunityUpper) 
			// 			) {
			// 				val = 1;
			// 			} else if (
			// 				((data.Builder >= defaultProfile.BuilderLower && data.Builder <= defaultProfile.BuilderUpper) &&
			// 				(data.Merchant >= defaultProfile.MerchantLower && data.Merchant <= defaultProfile.MerchantUpper) && 
			// 				(data.Innovator >= defaultProfile.InnovatorLower && data.Innovator <= defaultProfile.InnovatorUpper) && 
			// 				(data.Banker >= defaultProfile.BankerLower && data.Banker <= defaultProfile.BankerUpper) )||
			// 				((data.Intuitive >= defaultProfile.IntuitiveLower && data.Intuitive <= defaultProfile.IntuitiveUpper) &&
			// 				(data.Cognitive >= defaultProfile.CognitiveLower && data.Cognitive <= defaultProfile.CognitiveUpper) && 
			// 				(data.Practical >= defaultProfile.PracticalLower && data.Practical <= defaultProfile.PracticalUpper) &&
			// 				(data.Creative >= defaultProfile.CreativeLower && data.Creative <= defaultProfile.CreativeUpper) &&
			// 				(data.Independent >= defaultProfile.IndependentLower && data.Independent <= defaultProfile.IndependentUpper) && 
			// 				(data.Community >= defaultProfile.CommunityLower && data.Community <= defaultProfile.CommunityUpper))
			// 			) {
			// 				val = 2;
			// 			}else if (
			// 				((data.Builder <= defaultProfile.BuilderLower || data.Builder >= defaultProfile.BuilderUpper) ||
			// 				(data.Merchant <= defaultProfile.MerchantLower || data.Merchant >= defaultProfile.MerchantUpper) ||
			// 				(data.Innovator <= defaultProfile.InnovatorLower || data.Innovator >= defaultProfile.InnovatorUpper) || 
			// 				(data.Banker <= defaultProfile.BankerLower || data.Banker >= defaultProfile.BankerUpper) ) &&
			// 				((data.Intuitive <= defaultProfile.IntuitiveLower || data.Intuitive >= defaultProfile.IntuitiveUpper) ||
			// 				(data.Cognitive <= defaultProfile.CognitiveLower || data.Cognitive >= defaultProfile.CognitiveUpper) ||
			// 				(data.Practical <= defaultProfile.PracticalLower || data.Practical >= defaultProfile.PracticalUpper) ||
			// 				(data.Creative <= defaultProfile.CreativeLower || data.Creative >= defaultProfile.CreativeUpper) ||
			// 				(data.Independent <= defaultProfile.IndependentLower || data.Independent >= defaultProfile.IndependentUpper) || 
			// 				(data.Community <= defaultProfile.CommunityLower || data.Community <= defaultProfile.CommunityUpper))
			// 			) {
			// 				val = 3;
			// 			}
			// 			pf = defaultProfile.Name;
			// 			pfid = defaultProfile.ProfileId;
			// 		}else {
			// 			val = 0;
			// 			pf = '';
			// 			pfid = ''
			// 		}
			// 	}
			// 	return { val, pf, pfid };
			// },
			// UpdatePriorityData()
			// {
			// 	var currentProspectData = this.prospect.CciMap;

			// 	let ff1 = {
			// 		cciMap1:{
			// 			DateSubmitted:Date.now(),
			// 			Builder:currentProspectData.Builder,
			// 			Merchant:currentProspectData.Merchant,
			// 			Innovator:currentProspectData.Innovator,
			// 			Banker:currentProspectData.Banker,
			// 			Intuitive:currentProspectData.Builder+currentProspectData.Merchant,
			// 			Cognitive:currentProspectData.Innovator+currentProspectData.Banker,
			// 			Practical:currentProspectData.Builder+currentProspectData.Banker,
			// 			Creative:currentProspectData.Merchant+currentProspectData.Innovator,
			// 			Independent:currentProspectData.Builder+currentProspectData.Innovator,
			// 			Community:currentProspectData.Banker+currentProspectData.Merchant,
			// 		}
			// 	}

			// 	let pdata  = this.calculatePriority(ff1.cciMap1);
			// 	// var aPriority = pdata.val;
			// 	// var bProfileName = pdata.pf;
			// 	// var cProfileId = pdata.pfid;

			// 	this.priorityModalData.CciMap['Priority'] = pdata.val;

			// 	// UPDATE PRIORITY VALUE
			// 	let updatedPriority = { 'CciMap.Priority': pdata.val }
			// 	db.doc(`Users/${this.user.id}/Prospects/${this.priorityModalData.id}`).update(updatedPriority);

			// },
			// openPriorityModal(message,type) {
			// 	let emailDetailsObject = {
			// 			user:this.user,
			// 			prospect:this.prospect,
			// 			message:message,
			// 			type:type
			// 		}
			// 	this.emailData = emailDetailsObject;
			// 	this.priorityModalData = this.prospect;
			// 	let abc =  this.user.CciProfiles.find(cp => cp.Default == true);
			// 	this.UpdatePriorityData();
			// 	//eslint-disable-next-line
			// 	//console.log('abc1', abc);
			// 	if (abc) {
			// 		this.defaultProfileData = abc;
			// 	}else {
			// 		this.defaultProfileData = {}
			// 	}
			// 	this.$bvModal.show('priorityModal');
			// }
			
        },
        watch: {
			// message: {
			// 	/* this handler controls the growth of the input text-area */
			// 	handler() {
			// 		setTimeout(() => {
			// 			this.$refs.input.rows = 1;
			// 			while (this.$refs.input.scrollHeight > this.$refs.input.offsetHeight && this.$refs.input.rows < 4) {
			// 				this.$refs.input.rows += 1;
			// 				this.$refs.messageLog.scrollTop = this.$refs.messageLog.scrollHeight;
			// 			}
			// 		})
			// 	}
			// },
			grpmessages: {
				immediate: true,
				handler() {
					this.$emit('groupopen', 'prosp');
					this.$nextTick(() => {
						if (this.$refs.grpmessageLog) {
							this.$refs.grpmessageLog.scrollTop = this.$refs.grpmessageLog.scrollHeight;
							this.ScrollCount = 1;
							
						}
					})
				}
			},
        },
        data() {
            return {
				searchQuery:'',
				currentCovno:'',
				FriendlyNameSaveIF:false,
				FriendlyNameEditIF:true,

				FriendlyNameStatic:true,
				FriendlyNameEditField:false,

				// FriendlyNameEdit:false,
				// FriendlyNameStatic:true,
				// FriendlyNameEditIf:false,
				OnLoadMsgLimit : 100,
				ScrollCount : 1,
				temps: false,
				sched: false,
				sending: {},
				failed: {},
				emailData:{},
				priorityModalData:{},
				defaultProfileData:{},
				message: '',
				form: {
					name: '',
					body: '',
					date: '',
					time: '',
					friendlyName:''
				},
				fileData: null,
				uplodedFilePath: '',
				uploadValue: 0,
				hideDiv:false,
				supportedType: ['audio/basic','audio/L24','audio/mp4','audio/mpeg','audio/ogg','audio/vorbis','audio/vnd.rn-realaudio',
					'audio/vnd.wave','audio/3gpp','audio/3gpp2','audio/ac3','audio/vnd.wave','audio/webm','audio/amr-nb','audio/amr',
					'video/mpeg','video/mp4','video/quicktime','video/webm','video/3gpp','video/3gpp2','video/3gpp-tt','video/H261',
					'video/H263','video/H263-1998','video/H263-2000','video/H264','image/jpeg','image/gif','image/png','image/bmp',
					'text/vcard','text/csv','text/rtf','text/richtext','text/calendar','text/directory','application/pdf'
					],
				imageFormatArray:['jpg','jpeg','png','gif','bmp'],
				audioFormatArray:['basic','L24','mpeg','ogg','vorbis','vnd.rn-realaudio','vnd.wave','3gpp','3gpp2','ac3','vnd.wave','amr-nb','amr'],
				videoFormatArray:['webm','mpeg','mp4','3gpp','quicktime','3gpp2','3gpp-tt','H261','H263','H263-1998','H263-2000','H264',],
				documentFormatArray:['pdf','vcard','csv','rtf','richtext','calendar','directory'],
				messageType:'',
				isSending:false,
				isScheduleTemplate:false,
				token:'',
				muted: false,
				onPhone: false,
				log: 'Connecting...',
				connection: null,
				callProspFullName:'',
				isShowTemplateList:true,
				templateForm:{
					Name:'',
					Body:'',
				}
            }
        },
		updated() {
			// if (this.convo && this.convo.Unread) {
			if (this.activegroupConvo) {
				// this.convo.Unread = 0;
				db.doc(`Conversations_v2/${this.activegroupConvo}`).update({Unread: 0});
				this.$store.commit('globals/SET', { var: 'unreadCountTotal', val: this.unreadCountTotal-1 });
			}
		},
		created() {

			//eslint-disable-next-line
			console.log('THIS.PROSPECT', this.grpmessages);

			// var self = this;

			// // Fetch Twilio capability token from our Node.js server
			// axios.get("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/token")
			// .then(response => {
			// 	this.token = response.data.token;
			// 	Device.setup(this.token);
			// }).catch(err => alert(`Could not fetch token: ${err}`));

			// // Configure event handlers for Twilio Device
			// Device.disconnect(function() {
			// 	self.onPhone = false;
			// 	self.connection = null;
			// 	self.log = 'Call ended.';
			// });

			// Device.ready(function() {
			// 	self.log = 'Connected';
			// });
		}
    }
</script>

<style >
	.input {
		resize: none;
	}

	.twemoji-textarea-outer > #twemoji-textarea {
		max-height: 100px;
	}
	/* .custom-dropdown button {
    border: 1px solid #dee2e6 im !important;
	} */
.custom-dropdown {
       border: 1px solid #dee2e6 !important;
    border-radius: 4px !important;
}
.custom-dropdown .dropdown-toggle{
	display: block !important;color: #042b79;padding: 5px 7px;    font-weight: bold;
}
.custom-dropdown .dropdown-toggle:after{
	display: none !important;
}
button#btn-emoji-default {
    margin-left: 0px ;
}
.show_star {
	background-color:  transparent;
}
.show_star:hover {
	background-color: transparent;fill: rgba(4,43,121,.3);
}
.red {
	background-color: transparent;
}
.before-icon .red {
	font-size: 18px;margin-right: 5px;
	color: red;
	font-weight: 800;
	object-fit: contain;
	object-position: center;
}
.before-icon .yellow {
	font-size: 18px;
	color:#ffc107;
	font-weight: 800;
	object-fit: contain;
	object-position: center;
}
.before-icon .gray  {
	font-size: 18px;
	color:gray;
	font-weight: 800;
	object-fit: contain;
	object-position: center;
}

.scedule-emoji button#btn-emoji-default {
    margin-left: 0px;margin-bottom: 50px;
    padding-left: 12px;
}




/* calling popup css */
.calling_icons button {
    border: none;padding:0px 15px;outline: none;
    background-color: transparent;
}

.calling_icons button i {
    font-size: 10px;
}
.calling_icons button:focus{
	outline: none;border: none;
}
button.mic_btn .fa-icon {
    font-size: 10px;
}

.calling-container {
    display: flex;
    align-items: center;
}

.calling_leftside > div {
    width: 70px;
    height: 70px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}





.calling_icons {
    background: rgb(200 213 236 / 11%);
    border-radius: 25px;
    padding: 7px 10px;
    display: flex;
    align-items: center;
}
.calling_icons button svg {
	fill: #fff !important;
	width: 15px !important;
	height: 20px !important;
}
button.reject_btn {
    background: red;
    padding: 0px;
    width: 30px;
    height: 30px;
    border-radius: 100%;
}
div#DailerModal___BV_modal_body_ {
    background: #02163d;padding:5px;
}
header#DailerModal___BV_modal_header_ {
    padding: 5px 20px;
}

#DailerModal .modal-dialog.modal-sm {
    max-width: 420px !important;
}
.calling-container span {
    font-size: 17px;
    color: #fff;
    font-weight: 700;
    /* margin: 0px 10px; */
    width: 100%;
}
.calling_icons button.reject_btn svg.text-blue.fa-icon {
    transform: rotate(
225deg
);
}
.calling_icons button:first-child{
	padding-right: 19px;
}



#DailerModal___BV_modal_content_ .modal-header .close {
	display: none !important;
}


h5#DailerModal___BV_modal_title_ {
    margin-bottom: 0;
    line-height: 1.5;
    font-size: 14px;
    color: #fff;
}
header#DailerModal___BV_modal_header_ {
    padding: 7px 20px;
    background: rgb(39 59 96);
    overflow: hidden;
}
.modal-content {
    border-radius: 12px;
    overflow: hidden;
}
div#DailerModal___BV_modal_body_ {
    background: #02163d;
    padding: 8px 8px;
}
/* .calling_leftside {
    width: 100px;
} */
.calling_leftside > div {
    width: 90px;
    border-radius: 8px;
    height: 90px;
    margin-top: -35px;
    background: #fff;
    display: flex;
    align-items: center;
}
.calling_rightside {
    width: 100%;
    margin-left: 10px;
    display: flex;
    align-items: center;
}
.calling-container span {
    font-size: 17px;
    color: #fff;
    font-weight: 700;
    /* margin: 0px 10px; */
    width: 100%;
}
button.mic_btn_mute {
    margin-right: 4px;
    padding-left: 11px !important;
    padding-right: 11px !important;
}
.calling_icons button:nth-child(2) svg {
    width: 17px !important;
}
.calling_icons button:nth-child(1) svg{
	width: 12px !important;
}
.calling_icons div button.mic_btn_mute svg {
    width: 20px !important;
}
.calling_icons button:nth-child(3) svg.text-blue.fa-icon {
    width: 17px !important;
}
.modal-content{
	border-radius: 8px !important;overflow: hidden;
}
.calling_icons button:nth-child(3){
    padding-left: 6px;
    padding-right: 20px;
 } 
 
 button.btn.border.schedule-upload.schedule-upload1.btn-outline {
    width: 37px;
    height: 37px;
    top: 140px;
    display: flex;
    align-items: center;
    padding: 0px !important;
}
.twemoji-textarea-outer > #twemoji-textarea {
    max-height: 126px;
    margin-left: 0;
}
.schedule-textbox .schedule-upload {
    /* bottom: 0 !important; */
    left: 10px !important;
    /* top: 50px !important; */
    position: absolute !important;
    z-index: 9;
    /* top: 0; */
    padding: 5px 7px !important;
    margin-bottom: 10px !important;
}
.schedule-textbox .schedule-textbox .twemoji-textarea-outer {
    max-height: 140px;
    min-height: 150px !important;
}
.schedule-textbox div#twemoji-textarea {
    min-height: 140px;
}

.testmove{
    display: block;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    padding: 20px;
    border-radius: 6px;
    height: 80px;
    width: 340px;
    margin: 100px;
    background: rgb(10 35 85);
    color: white;
    z-index: 1111;
}
/* .modaltitle {
    background: rgb(39 59 96);
    display:block;
    width:100%;
    color: white;
  } */

.modaltitle{
	background: transparent;
    display: block;position: unset !important;
    width: 100%;
    color: white;
    font-weight: 600;
    letter-spacing: 0.5px;
}
.custom-btn:hover {
	color: #fff !important;
}
.custom-save-btn {
	margin-left: auto !important;
	margin-right: 0 !important;
}	
.custom-btn {
	background: #007bff !important;
	padding: 10px !important;
    color: #fff !important;
    font-size: 12px;
}
.custom-save-btn{
	display: flex !important;
	justify-content: center !important;
	width: 100%;
	max-width: 150px !important;
	text-align: center;
	margin-left: auto !important;
	margin-right: 0 !important;
}
.custom-border{
	border: 1px solid #ced4da;
	padding: 20px;
	border-radius: 4px;
}
#TemplateModal___BV_modal_content_ h5#TemplateModal___BV_modal_title_ {
	display: flex;
	width: 90%;
	justify-content: space-between;
}
button.reply-btn {
    position: absolute;
    right: 55px;
    /* top: 0; */
    /* bottom: 0; */
    /* display: flex; */
    align-items: center;
    height: auto;
    margin-top: -4px;
    background: #02163d;
    border: transparent;
}
button.reply-btn:focus{
	outline: none !important;border: none;box-shadow: none !important;
}
button.reply-btn:hover{
	background: #02163d;
}
header#EmailModal___BV_modal_header_ {
    position: relative;
}

</style>

<style>
.multi-range-slider .thumb::before{
	border: solid 4px #042b79;
}
.nameeidtspan{
	margin-left: 20px;
	cursor: pointer;
}
.templatesearchbar{
	margin-bottom: 10px
}
</style>